var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareonfacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.484,
    height: 27.483,
    viewBox: "0 0 27.484 27.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "facebook_copy",
    "data-name": "facebook copy",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M27.484,13.742A13.742,13.742,0,1,1,13.742,0,13.742,13.742,0,0,1,27.484,13.742Zm0,0",
    transform: "translate(0 0)",
    fill: "#4a7aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    d: "M154.457,71.357v3.112s-3.573-.519-3.573,1.786v2.3h3.227l-.4,3.515h-2.824v9.162h-3.573V82.075l-3.054-.058V78.56h3V75.909a4.525,4.525,0,0,1,3.688-4.667A10.382,10.382,0,0,1,154.457,71.357Zm0,0",
    transform: "translate(-136.514 -67.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    d: "M259.865,74.469V71.357a10.382,10.382,0,0,0-3.515-.115,5.448,5.448,0,0,0-.705.18V91.236h.647V82.074h2.823l.4-3.515h-3.227v-2.3C256.292,73.95,259.865,74.469,259.865,74.469Zm0,0",
    transform: "translate(-241.922 -67.314)",
    fill: "#dce1eb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareonfacebook);
export default __webpack_public_path__ + "static/media/shareonfacebook.5687ffb86483690f25dd7a2e246be524.svg";
export { ForwardRef as ReactComponent };